<template>
  <v-app>
    <Header />
    <Gnb />
    <router-view />
  </v-app>
</template>

<script>
import Header from '../../views/common/header';
import Gnb from '../../views/common/gnb';

export default {
  components: {
    Header,
    Gnb,
  },
};
</script>
